import * as React from "react";
import { Icon } from "sb-resp-lib";

export class CloseButton extends React.Component<{
    handler: (MouseEvent) => void
}, {}> {

    render() {
        const { handler } = this.props;
        return (
            <button
                className="rj-pulse-bet-markets__close-button"
                onClick={handler}>
                <Icon i="i-12 i-o-pulsebet-clear" />
            </button>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./blocks/PulseBetMarkets/components/CloseButton/CloseButton.tsx